<template>
    <tr>
        <td>
            <barcode :value="asset.number" format="barcode-format" :fontSize="10">
                {{ $t('ui.notifications.error.exception_error_please_contact_the_system_supplier') }}.
            </barcode>
        </td>
        <td>{{asset.number}}</td>
        <td>{{asset.note}}</td>
        <td v-if="is_processing">
            <i class="notched circle loading icon"></i>
        </td>
        <td v-else>
            <!-- <router-link :to="{name: 'print_asset', params: {id: asset.id}}" class="ui basic button">
                列印
            </router-link> -->
            <router-link :to="{name: 'edit_asset', params: {id: asset.identity}}" class="ui basic primary button">
                {{ $t('ui.general.edit') }}
            </router-link>
            <button class="ui basic negative button" @click.prevent="delete_asset()">
                {{ $t('ui.general.delete') }}
            </button>
        </td>
    </tr>
</template>

<script>
import VueBarcode from '@chenfengyuan/vue-barcode'
export default {
    props: {
        asset: Object
    },
    data() {
        return {
            is_processing: false,
        }
    },
    mounted() {
    },
    computed: {
        index() {
            return this.$parent
        },
        layout() {
            return this.$parent.$parent
        }
    },
    methods: {
        delete_asset() {
            var result = confirm(
                this.$t('ui.notifications.warning.are_you_sure_to_delete_it')
            )
            if (result) {
                this.is_processing = true
                this.$parent.errors = []
                var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_asset_delete).parse(
                    {
                        "asset_identity": this.asset.identity,
                    },
                    ""
                )
                axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                    .then(response => {
                        if (response.data.status == "success") {
                            this.index.fetch_assets()
                            this.$noty.success(
                                this.$t('ui.notifications.success.delete__name', {
                                    name: this.$t('models.assets')
                                })
                            )
                        } else {
                            this.index.errors.push(response.data.errors)
                            this.$noty.errors(
                                this.$t('ui.notifications.error.delete__name', {
                                    name: this.$t('models.assets')
                                })
                            )
                        }
                    })
                    .catch(error => {
                        this.index.errors.push(
                            this.$t('ui.notifications.error.delete__name', {
                                name: this.$t('models.assets'),
                                reason: ': ' + error.response.status
                            })
                        )
                    })
                this.is_processing = false
            }
        }
    },
    components: {
        'barcode': VueBarcode
    }
}
</script>

<style scoped>
</style>
